/**
 * How the sidebar is presented.
 * - Docked: a column beside the content that can collapse to an icon rail.
 * - Drawer: rendered inside an off-canvas panel; always shows labels.
 */
export enum SidebarMode {
  Docked = 'docked',
  Drawer = 'drawer',
}
